"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseINewClientDefaults = void 0;
const inew_client_defaults_mail_settings_1 = require("./inew-client-defaults-mail-settings");
function parseINewClientDefaults(data) {
    if (data.mailSettings !== null && typeof data.mailSettings === 'object')
        data.mailSettings = (0, inew_client_defaults_mail_settings_1.parseINewClientDefaultsMailSettings)(data.mailSettings);
    return data;
}
exports.parseINewClientDefaults = parseINewClientDefaults;
